import { IconButton } from "@mui/material";
import { GridColDef } from "@mui/x-data-grid-pro";

import DynamicIcon from "../../../../../../common/components/dynamic_icon";

// GenerateObraEstruturaTreinamentoColumns

type Props = {
  onActionEditar: (IdPlanoTreinamento: number | null, openState: boolean) => void,
  onActionDeletar: (IdPlanoTreinamento: number | null, openState: boolean) => void,
};

export const GenerateObraEstruturaTreinamentoColumns = ({
  onActionEditar,
  onActionDeletar,
}: Props): GridColDef[] => {
  return [
    {
      field: "Cargo",
      filterable: false,
      headerName: "Cargo",
      flex: 1,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: "TipoTreinamento",
      filterable: false,
      headerName: "Treinamentos",
      flex: 2,
      minWidth: 150,
      sortable: false,
      renderCell: (params) => (
        <div className="w-full h-full flex items-center text-xs">
          {params.value}
        </div>
      ),
    },
    {
      field: 'IdPlanoTreinamento',
      sortable: false,
      filterable: false,
      headerName: 'Ações',
      width: 100,
      minWidth: 100,
      renderCell: (params) => {
        return (
          <div className="flex items-center justify-center w-full h-full gap-2">
            <IconButton onClick={() => onActionEditar(params.value, true)}>
              <DynamicIcon nameIcon="EditRounded" size={25} className="dark:text-white text-primary-green" />
            </IconButton>

            <IconButton onClick={() => onActionDeletar(params.value, true)}>
              <DynamicIcon nameIcon="DeleteForeverRounded" size={25} className="text-red-500" />
            </IconButton>
          </div>
        );
      }
    },
  ];
}